import React from "react";
import cloud from "../../image/voiceProcessor-logo.png";
import Card from "./Card";

// Centered card shared by the auth pages, over the app-wide BlueprintBackground.
export default function AuthLayout({ title, subtitle, children, footer }) {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center">
          <img src={cloud} alt="Voice Processor" className="h-auto w-44" />
        </div>
        <Card>
          <div className="mb-6 text-center">
            <h1 className="font-display text-2xl font-semibold tracking-tight text-white">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-2 text-sm leading-relaxed text-white/60">
                {subtitle}
              </p>
            )}
          </div>
          {children}
        </Card>
        {footer && (
          <div className="mt-6 text-center text-sm text-white/60">{footer}</div>
        )}
      </div>
    </div>
  );
}
